import { MaskedLine, Micro, Reveal, SlideBody, SlideShell } from "../shared";

const Kpi = ({ value, label, delay }) => (
  <Reveal delay={delay}>
    <div className="tnum font-serif text-5xl tracking-tight text-[#B8860B] sm:text-6xl lg:text-7xl">{value}</div>
    <div className="mt-3 font-mono text-[10px] uppercase tracking-[0.28em] text-[#64748B]">{label}</div>
  </Reveal>
);

const Op = ({ children, delay }) => (
  <Reveal delay={delay} className="pb-10">
    <span className="font-serif text-4xl text-[#0B152C]/25 sm:text-5xl">{children}</span>
  </Reveal>
);

export default function Slide06Adv() {
  return (
    <SlideShell theme="ivory" testid="slide-6-adv">
      <SlideBody>
        <Reveal>
          <Micro tone="ivory">05 · Investimento ADV</Micro>
        </Reveal>
        <h2 className="mt-5 font-serif text-4xl leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
          <MaskedLine delay={0.1}>UN INVESTIMENTO,</MaskedLine>
          <MaskedLine delay={0.22}>
            <em className="italic text-[#997A15]">NON UN COSTO.</em>
          </MaskedLine>
        </h2>

        <div className="mt-12 flex flex-wrap items-end gap-x-8 gap-y-6 lg:gap-x-12">
          <Kpi value="€20.000" label="Piano ADV · Anno 1" delay={0.35} />
          <Op delay={0.45}>÷</Op>
          <Kpi value="20" label="Ville nella Collection" delay={0.5} />
          <Op delay={0.6}>=</Op>
          <Kpi value="≈ €1.000" label="Per villa · all'anno" delay={0.65} />
        </div>

        <div className="mt-14 grid gap-4 md:grid-cols-2">
          <Reveal delay={0.8}>
            <div className="h-full border border-[#0B152C]/12 bg-white p-6 lg:p-7">
              <Micro tone="ivory">Target</Micro>
              <h3 className="mt-3 font-serif text-2xl tracking-tight text-[#0B152C]">USA — California · Florida</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#334155]">
                Viaggiatori high-spending, raggiunti con advertising dedicato: prenotazioni dirette
                internazionali sulla Collection.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.9}>
            <div className="flex h-full items-center justify-between gap-6 bg-[#0B152C] p-6 lg:p-7">
              <div>
                <Micro>Proiezione 2028</Micro>
                <p className="mt-3 text-sm leading-relaxed text-[#94A3B8]">
                  Il modello replicato sull&rsquo;intera Collection.
                </p>
              </div>
              <div className="text-right">
                <div className="tnum font-serif text-4xl tracking-tight text-[#D4AF37] lg:text-5xl">€100K</div>
                <div className="mt-2 font-mono text-[10px] uppercase tracking-[0.25em] text-white/45">
                  su 100 ville
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </SlideBody>
    </SlideShell>
  );
}
